import React, { ReactNode } from 'react';
import Header from '@/components/shadowban/header';
import ChooseContent from '@/components/shadowban/ChooseContent';
import WhyDownloadStoriesContent from '@/components/shadowban/WhyDownloadStoriesContent';
import UseViewerForInstagram from '@/components/shadowban/UseViewerForInstagram';
import FaqContent from '@/components/shadowban/FAQContent';
import BestTipsContent from '@/components/shadowban/BestTipsContent';

export default function LandingPage({ data, children }: { data?: any; children?: ReactNode }) {
  console.log({ data });
  const {
    contentInfo: {
      hero,
      'section-2': section2,
      'section-4': section4,
      'section-faq': sectionFaq,
      'section-top-blog': sectionTopBlog,
      'section-user-reviews': sectionUserReviews,
    } = {},
    faqList,
    blogList,
  } = data || {};

  return (
    <>
      <Header data={hero} />
      {children}
      <ChooseContent data={section2} />
      <WhyDownloadStoriesContent data={section4} />
      <UseViewerForInstagram data={sectionUserReviews} />
      <FaqContent faqList={faqList} faqInfo={sectionFaq} />
      <BestTipsContent title={sectionTopBlog?.title} blogList={blogList} />
    </>
  );
}
